import { readJwtScope, readJwtUserId } from "../api/clientJwt";

/**
 * Resolve o id de presença/socket.
 * - scope=workspace: sempre o id do JWT (não confiar em userData stale/clonado).
 * - partner/platform: JWT é do portal; usa userData (tenant via /users/me).
 */
export function resolvePresenceUserId(bearerToken, userData) {
  const scope = readJwtScope(bearerToken) || "workspace";
  if (scope === "workspace") {
    const jwtId = readJwtUserId(bearerToken);
    if (jwtId != null) return jwtId;
  }
  const local = Number(userData?.id);
  return Number.isFinite(local) && local > 0 ? local : null;
}
